import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuctionHallModalService {

  private selectedAuctionHallSubject = new BehaviorSubject<any>(null);
  public selectedAuctionHall$ = this.selectedAuctionHallSubject.asObservable();

  constructor() { }

  setSelectedAuctionHall(auctionHall: any): void {
    this.selectedAuctionHallSubject.next(auctionHall);
  }

  getSelectedAuctionHall(): any | null {
    return this.selectedAuctionHallSubject.value;
  }

  clearSelectedAuctionHall(): void {
    this.selectedAuctionHallSubject.next(null);
  }
}
